import { render, staticRenderFns } from "./StacHeader.vue?vue&type=template&id=40538cfc&scoped=true"
import script from "./StacHeader.vue?vue&type=script&lang=js"
export * from "./StacHeader.vue?vue&type=script&lang=js"
import style0 from "./StacHeader.vue?vue&type=style&index=0&id=40538cfc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40538cfc",
  null
  
)

export default component.exports